import { render } from "./NewLoanCalculatorResultDesktop.vue?vue&type=template&id=4b9fb18a"
import script from "./NewLoanCalculatorResultDesktop.vue?vue&type=script&lang=js"
export * from "./NewLoanCalculatorResultDesktop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__